import { useRef as r, useEffect as t } from "react";
function n() {
  const e = r(!1);
  return t(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e.current;
}
export {
  n as useIsMounted
};
//# sourceMappingURL=index4.js.map
